exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart[data-v-4351c24a]{margin-top:3em;font-size:13px}", ""]);

// exports
